export const getInitial = (template) => ({ pending: false, failed: false, ...template });
export const wait = (a) => ({ ...a, failed: false, pending: true });
export const fail = (a) => ({ ...a, failed: true, pending: false });
export const reset = (a) => ({ ...a, failed: false, pending: false });
